// import React, { useState } from 'react';
// import { motion } from 'framer-motion';
// import TopMenu from '../../../../TopMenu';

// /* ── SVG: Yes (green checkmark — currently studying) ────────────────────── */
// const YesSVG = () => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 512 512">
//     <g>
//       <path fill="#bc7c63" d="M286.738 479.474v12.793c0 10.898 8.835 19.733 19.733 19.733s19.733-8.835 19.733-19.733v-12.793zM306.471 265.982c-6.704 0-14.322-.497-20.763-1.444v78.058c-.036 1.625 1.248 3.147 3.076 3.147h37.42v-81.205a135.715 135.715 0 0 1-19.733 1.444z"/>
//       <path fill="#ab6b51" d="M307.837 492.267v-12.793h-21.098v12.793c0 10.898 8.835 19.733 19.733 19.733 3.884 0 7.496-1.138 10.549-3.076-5.514-3.5-9.184-9.643-9.184-16.657zM306.471 265.982c-6.704 0-14.322-.497-20.763-1.444v78.057c-.036 1.626 1.247 3.147 3.076 3.147h19.052v-79.786c-.455.005-.907.026-1.365.026z"/>
//       <path fill="#fed2a4" d="M358.991 342.652h-69.177c-1.829 0-3.112-1.522-3.076-3.147v-56.144c0-6.776-5.477-12.296-12.254-12.319h-.065a17.525 17.525 0 0 0-15.886 10.113c-6.513 13.947-4.54 29.318-24.97 49.65-10.077 10.029-23.81 15.519-38.027 15.519h-18.581v120.687h11.786a60.975 60.975 0 0 1 28.857 7.261 60.967 60.967 0 0 0 28.857 7.261h88.819c9.588 0 17.36-7.772 17.36-17.36s-7.772-17.36-17.36-17.36h7.905c9.588 0 17.36-7.772 17.36-17.36s-7.772-17.36-17.36-17.36h7.905c9.588 0 17.36-7.772 17.36-17.36s-7.772-17.36-17.36-17.36h7.905c9.588 0 17.36-7.772 17.36-17.36.002-9.589-7.77-17.361-17.358-17.361z"/>
//       <path fill="#ffbd86" d="M206.833 361.539c0-8.046 3.951-15.165 10.014-19.537a54.65 54.65 0 0 1-21.31 4.322h-18.581v120.687h11.786c6.157 0 12.254.943 18.091 2.758z"/>
//       <circle cx="306.471" cy="134.536" r="134.536" fill="#43cb8e"/>
//       <path fill="#00ba66" d="M201.124 134.536c0-69.37 52.505-126.47 119.942-133.746-4.795-.517-9.663-.79-14.595-.79-74.302 0-134.536 60.234-134.536 134.536s60.234 134.536 134.536 134.536c4.932 0 9.8-.273 14.594-.79-67.436-7.276-119.941-64.376-119.941-133.746z"/>
//       <circle cx="306.471" cy="134.536" r="107.879" fill="#00ba66"/>
//       <path fill="#00a855" d="M227.781 134.536c0-54.63 40.608-99.768 93.285-106.893a108.77 108.77 0 0 0-14.594-.986c-59.58 0-107.879 48.299-107.879 107.879s48.299 107.879 107.879 107.879c4.95 0 9.821-.341 14.594-.986-52.677-7.125-93.285-52.264-93.285-106.893z"/>
//       <g fill="#ffbd86">
//         <path d="M335.276 446.813h7.91-47.626a7.726 7.726 0 1 0 0 15.452h56.966c-.951-8.688-8.308-15.452-17.25-15.452zM351.089 412.093H295.56a7.726 7.726 0 1 0 0 15.452h64.871c-.951-8.689-8.308-15.452-17.25-15.452h7.905zM295.56 392.825h72.777c-.95-8.689-8.308-15.453-17.25-15.453H295.56a7.726 7.726 0 0 0-7.726 7.726 7.726 7.726 0 0 0 7.726 7.727zM358.991 342.652h-66.866c-2.541 1.565-4.292 4.696-4.292 7.727a7.726 7.726 0 0 0 7.726 7.726h80.682c-.95-8.69-8.307-15.453-17.25-15.453z"/>
//       </g>
//       <path fill="#dfebfa" d="M173.162 333.304h-31.927v143.222h31.927a6.886 6.886 0 0 0 6.886-6.886V340.19a6.887 6.887 0 0 0-6.886-6.886z"/>
//       <path fill="#b1dbfc" d="M141.235 333.304h22.64v143.222h-22.64z"/>
//       <path fill="#60b8fe" d="M134.482 320.128H80.836c-5.436 0-9.843 4.407-9.843 9.843v149.888c0 5.436 4.407 9.843 9.843 9.843h53.646c5.436 0 9.843-4.407 9.843-9.843V329.971c.001-5.436-4.407-9.843-9.843-9.843z"/>
//       <path fill="#23a8fe" d="M107.659 479.859V329.971c0-5.436 4.407-9.843 9.844-9.843H80.836c-5.436 0-9.843 4.407-9.843 9.843v149.888c0 5.436 4.407 9.843 9.843 9.843h36.667c-5.437.001-9.844-4.406-9.844-9.843z"/>
//       <path fill="#dfebfa" d="M367.153 98.617c-6.207-6.821-16.776-7.008-23.222-.561l-46.821 46.821a3.227 3.227 0 0 1-4.565 0l-20.92-20.92c-6.446-6.447-17.015-6.26-23.221.561-5.813 6.389-5.251 16.338.857 22.446l34.224 34.224c6.264 6.265 16.423 6.265 22.686 0l60.125-60.125c6.108-6.108 6.67-16.057.857-22.446z"/>
//       <path fill="#b1dbfc" d="m298.968 171.745-34.224-34.224c-4.882-4.882-6.209-12.215-3.581-18.226-4.632-.253-9.352 1.479-12.759 5.223-5.813 6.389-5.251 16.338.857 22.447l34.224 34.224c6.264 6.265 16.423 6.265 22.686 0l4.775-4.775c-4.315.17-8.685-1.375-11.978-4.669z"/>
//     </g>
//   </svg>
// );

// /* ── SVG: No (red X — not studying) ─────────────────────────────────────── */
// const NoSVG = () => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 512 512">
//     <g>
//       <path fill="#bc7c63" d="M286.738 479.474v12.793c0 10.898 8.835 19.733 19.733 19.733s19.733-8.835 19.733-19.733v-12.793zM306.471 265.982c-6.704 0-14.322-.497-20.763-1.444v78.058c-.036 1.626 1.248 3.147 3.076 3.147h37.42v-81.205a135.715 135.715 0 0 1-19.733 1.444z"/>
//       <path fill="#ab6b51" d="M307.837 492.267v-12.793h-21.098v12.793c0 10.898 8.835 19.733 19.733 19.733 3.884 0 7.496-1.138 10.549-3.076-5.514-3.5-9.184-9.643-9.184-16.657zM306.471 265.982c-6.704 0-14.322-.497-20.763-1.444v78.057c-.036 1.625 1.247 3.147 3.076 3.147h19.052v-79.786c-.455.005-.907.026-1.365.026z"/>
//       <path fill="#fed2a4" d="M358.991 342.652h-69.177c-1.829 0-3.112-1.522-3.076-3.147v-56.144c0-6.776-5.477-12.296-12.254-12.319h-.065a17.525 17.525 0 0 0-15.886 10.113c-6.513 13.947-4.54 29.318-24.97 49.65-10.077 10.029-23.81 15.519-38.027 15.519h-18.581v120.687h11.786a60.975 60.975 0 0 1 28.857 7.261 60.967 60.967 0 0 0 28.857 7.261h88.819c9.588 0 17.36-7.772 17.36-17.36s-7.772-17.36-17.36-17.36h7.905c9.588 0 17.36-7.772 17.36-17.36s-7.772-17.36-17.36-17.36h7.905c9.588 0 17.36-7.772 17.36-17.36s-7.772-17.36-17.36-17.36h7.905c9.588 0 17.36-7.772 17.36-17.36.002-9.589-7.77-17.361-17.358-17.361z"/>
//       <path fill="#ffbd86" d="M206.833 361.539c0-8.046 3.951-15.165 10.014-19.537a54.65 54.65 0 0 1-21.31 4.322h-18.581v120.687h11.786c6.157 0 12.254.943 18.091 2.758z"/>
//       <circle cx="306.471" cy="134.536" r="134.536" fill="#ff656f"/>
//       <path fill="#ff4756" d="M201.124 134.536c0-69.37 52.505-126.47 119.942-133.746-4.795-.517-9.663-.79-14.595-.79-74.302 0-134.536 60.234-134.536 134.536s60.234 134.536 134.536 134.536c4.932 0 9.8-.273 14.594-.79-67.436-7.276-119.941-64.376-119.941-133.746z"/>
//       <circle cx="306.471" cy="134.536" r="107.879" fill="#ff4756"/>
//       <path fill="#fc2d39" d="M227.781 134.536c0-54.63 40.608-99.768 93.285-106.893a108.77 108.77 0 0 0-14.594-.986c-59.58 0-107.879 48.299-107.879 107.879s48.299 107.879 107.879 107.879c4.95 0 9.821-.341 14.594-.986-52.677-7.125-93.285-52.264-93.285-106.893z"/>
//       <path fill="#dfebfa" d="M330.882 136.155a2.29 2.29 0 0 1 0-3.237l25.409-25.409c6.108-6.108 6.67-16.058.857-22.447-6.207-6.821-16.776-7.008-23.222-.561l-25.733 25.733a2.288 2.288 0 0 1-3.235-.002l-25.515-25.515c-6.108-6.108-16.057-6.67-22.446-.857-6.821 6.207-7.008 16.776-.561 23.222l25.838 25.839c.893.893.893 2.34 0 3.233l-25.838 25.839c-6.447 6.446-6.26 17.015.561 23.221 6.389 5.813 16.338 5.251 22.446-.857l25.515-25.515a2.288 2.288 0 0 1 3.235-.002l25.733 25.733c6.446 6.447 17.015 6.26 23.222-.561 5.813-6.389 5.251-16.338-.857-22.447l-25.409-25.41z"/>
//       <path fill="#b1dbfc" d="m278.07 161.991 25.839-25.839a2.286 2.286 0 0 0 0-3.233L278.07 107.08c-6.426-6.425-6.257-16.944.499-23.159-6.149-5.339-15.477-5.608-21.572-.062-6.821 6.207-7.009 16.776-.561 23.222l25.839 25.839c.893.893.893 2.34 0 3.233l-25.839 25.839c-6.447 6.446-6.26 17.015.561 23.221 6.095 5.546 15.423 5.277 21.572-.062-6.757-6.215-6.926-16.735-.499-23.16z"/>
//       <g fill="#ffbd86">
//         <path d="M335.276 446.813h7.91-47.626a7.726 7.726 0 1 0 0 15.452h56.966c-.951-8.688-8.308-15.452-17.25-15.452zM351.089 412.093H295.56a7.726 7.726 0 1 0 0 15.452h64.871c-.951-8.689-8.308-15.452-17.25-15.452h7.905zM295.56 392.825h72.777c-.95-8.689-8.308-15.453-17.25-15.453H295.56a7.727 7.727 0 0 0 0 15.453zM358.991 342.652h-66.866c-2.541 1.565-4.292 4.696-4.292 7.727a7.726 7.726 0 0 0 7.726 7.726h80.682c-.95-8.69-8.307-15.453-17.25-15.453z"/>
//       </g>
//       <path fill="#dfebfa" d="M173.162 333.304h-31.927v143.222h31.927a6.886 6.886 0 0 0 6.886-6.886V340.19a6.887 6.887 0 0 0-6.886-6.886z"/>
//       <path fill="#b1dbfc" d="M141.235 333.304h22.64v143.222h-22.64z"/>
//       <path fill="#60b8fe" d="M134.482 320.128H80.836c-5.436 0-9.843 4.407-9.843 9.843v149.888c0 5.436 4.407 9.843 9.843 9.843h53.646c5.436 0 9.843-4.407 9.843-9.843V329.971c.001-5.436-4.407-9.843-9.843-9.843z"/>
//       <path fill="#23a8fe" d="M107.659 479.859V329.971c0-5.436 4.407-9.843 9.844-9.843H80.836c-5.436 0-9.843 4.407-9.843 9.843v149.888c0 5.436 4.407 9.843 9.843 9.843h36.667c-5.437.001-9.844-4.406-9.844-9.843z"/>
//     </g>
//   </svg>
// );

// /* ── Data ─────────────────────────────────────────────────────────────────── */
// const OPTIONS = [
//   {
//     id:      'yes',
//     tag:     'ENROLLED',
//     icon:    <YesSVG />,
//     label:   'Yes, I am',
//     sub:     'Currently studying',
//     desc:    "We'll include education highlights, academic projects and internships prominently.",
//     accent:  '#00C9A7',
//     accentD: '#00FFD1',
//   },
//   {
//     id:      'no',
//     tag:     'GRADUATED',
//     icon:    <NoSVG />,
//     label:   "No, I'm not",
//     sub:     'Already graduated',
//     desc:    "We'll focus on work experience, achievements and professional skills sections.",
//     accent:  '#0A66C2',
//     accentD: '#4D9FFF',
//   },
// ];

// /* ── Styles ──────────────────────────────────────────────────────────────── */
// const CSS = `
// .cs-shell { min-height:100vh; font-family:'DM Sans',sans-serif; -webkit-font-smoothing:antialiased; position:relative; overflow:hidden; }
// .cs-shell.light { background:#F5F4F8; color:#1A1828; }
// .cs-shell.dark  { background:#050508; color:#E8E6F0; }

// .cs-orb { position:absolute; border-radius:50%; pointer-events:none; }
// .cs-orb-1 { width:550px; height:550px; top:-180px; left:-150px;   background:radial-gradient(circle, rgba(0,201,167,0.08) 0%, transparent 65%); }
// .cs-orb-2 { width:450px; height:450px; bottom:-150px; right:-100px; background:radial-gradient(circle, rgba(10,102,194,0.08) 0%, transparent 65%); }

// .cs-grid { position:absolute; inset:0; pointer-events:none; background-size:40px 40px; mask-image:radial-gradient(ellipse 80% 80% at 50% 50%, black, transparent); -webkit-mask-image:radial-gradient(ellipse 80% 80% at 50% 50%, black, transparent); }
// .cs-shell.dark  .cs-grid { background-image:linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px); }
// .cs-shell.light .cs-grid { background-image:linear-gradient(rgba(0,0,0,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(0,0,0,0.04) 1px, transparent 1px); }

// .cs-page { position:relative; z-index:1; min-height:calc(100vh - 64px); margin-top:64px; padding:64px 24px 80px; display:flex; flex-direction:column; align-items:center; gap:44px; }

// .cs-header { text-align:center; max-width:560px; }

// .cs-badge { display:inline-flex; align-items:center; gap:7px; font-size:11px; font-weight:700; letter-spacing:0.12em; text-transform:uppercase; padding:6px 14px; border-radius:100px; margin-bottom:20px; }
// .cs-shell.dark  .cs-badge { background:rgba(0,201,167,0.1); border:1px solid rgba(0,201,167,0.25); color:#00FFD1; }
// .cs-shell.light .cs-badge { background:rgba(0,150,120,0.08); border:1px solid rgba(0,150,120,0.2); color:#007A5E; }

// .cs-title { font-family:'Syne',sans-serif; font-size:clamp(26px,4vw,40px); font-weight:800; letter-spacing:-0.04em; line-height:1.1; margin-bottom:14px; }
// .cs-shell.dark  .cs-title { color:#F0EEF8; }
// .cs-shell.light .cs-title { color:#1A1828; }
// .cs-title span { background:linear-gradient(135deg,#00FFD1,#4D9FFF); -webkit-background-clip:text; background-clip:text; -webkit-text-fill-color:transparent; }
// .cs-shell.light .cs-title span { background:linear-gradient(135deg,#00C9A7,#0A66C2); -webkit-background-clip:text; background-clip:text; -webkit-text-fill-color:transparent; }

// .cs-sub { font-size:15px; line-height:1.7; }
// .cs-shell.dark  .cs-sub { color:#6E6B80; }
// .cs-shell.light .cs-sub { color:#8B879E; }

// /* Cards */
// .cs-cards { display:grid; grid-template-columns:repeat(2,1fr); gap:20px; width:100%; max-width:640px; }
// @media(max-width:580px){ .cs-cards{ grid-template-columns:1fr; } }

// .cs-card { border-radius:20px; padding:28px 22px 22px; cursor:pointer; position:relative; overflow:hidden; border:1.5px solid; text-align:left; background:none; display:flex; flex-direction:column; transition:transform 0.22s, box-shadow 0.22s, border-color 0.22s; }
// .cs-shell.dark  .cs-card { background:#0D0D12; border-color:rgba(255,255,255,0.06); }
// .cs-shell.light .cs-card { background:#FFFFFF; border-color:rgba(0,0,0,0.08); box-shadow:0 2px 16px rgba(0,0,0,0.05); }

// .cs-card:hover { transform:translateY(-6px); }
// .cs-shell.dark  .cs-card:hover  { border-color:var(--ac-d); box-shadow:0 12px 40px color-mix(in srgb, var(--ac-d) 18%, transparent); }
// .cs-shell.light .cs-card:hover  { border-color:var(--ac);   box-shadow:0 12px 40px color-mix(in srgb, var(--ac)   15%, transparent); }
// .cs-shell.dark  .cs-card.active { border-color:var(--ac-d); box-shadow:0 0 0 3px color-mix(in srgb, var(--ac-d) 18%, transparent); transform:translateY(-6px); }
// .cs-shell.light .cs-card.active { border-color:var(--ac);   box-shadow:0 0 0 3px color-mix(in srgb, var(--ac)   15%, transparent); transform:translateY(-6px); }

// .cs-glow { position:absolute; inset:0; border-radius:20px; pointer-events:none; opacity:0; transition:opacity 0.35s; background:radial-gradient(ellipse at 50% 0%, var(--glow,transparent), transparent 70%); }
// .cs-card:hover .cs-glow, .cs-card.active .cs-glow { opacity:1; }

// .cs-card-top { display:flex; justify-content:space-between; align-items:flex-start; margin-bottom:16px; }
// .cs-card-icon { transition:transform 0.25s; flex-shrink:0; }
// .cs-card:hover .cs-card-icon { transform:scale(1.08) translateY(-2px); }

// .cs-card-tag { font-size:10px; font-weight:700; letter-spacing:0.1em; padding:4px 10px; border-radius:100px; align-self:flex-start; margin-top:4px; }
// .cs-shell.dark  .cs-card-tag { color:var(--ac-d); background:color-mix(in srgb, var(--ac-d) 12%, transparent); border:1px solid color-mix(in srgb, var(--ac-d) 30%, transparent); }
// .cs-shell.light .cs-card-tag { color:var(--ac);   background:color-mix(in srgb, var(--ac)   10%, transparent); border:1px solid color-mix(in srgb, var(--ac)   25%, transparent); }

// .cs-card-name { font-family:'Syne',sans-serif; font-size:20px; font-weight:800; letter-spacing:-0.02em; margin-bottom:4px; }
// .cs-shell.dark  .cs-card-name { color:#EDEAF5; }
// .cs-shell.light .cs-card-name { color:#1A1828; }

// .cs-card-sub { font-size:12px; font-weight:500; margin-bottom:12px; }
// .cs-shell.dark  .cs-card-sub { color:#4A4760; }
// .cs-shell.light .cs-card-sub { color:#B0ACC4; }

// .cs-divider { height:1px; margin-bottom:14px; }
// .cs-shell.dark  .cs-divider { background:rgba(255,255,255,0.06); }
// .cs-shell.light .cs-divider { background:rgba(0,0,0,0.06); }

// .cs-card-desc { font-size:13px; line-height:1.65; margin-bottom:20px; flex:1; }
// .cs-shell.dark  .cs-card-desc { color:#6E6B80; }
// .cs-shell.light .cs-card-desc { color:#8B879E; }

// .cs-card-cta { width:100%; padding:11px 0; border-radius:10px; border:none; font-family:'DM Sans',sans-serif; font-size:14px; font-weight:700; cursor:pointer; transition:filter 0.2s, transform 0.15s; }
// .cs-shell.dark  .cs-card-cta { background:var(--ac-d); color:#050508; }
// .cs-shell.light .cs-card-cta { background:var(--ac);   color:#fff; }
// .cs-card-cta:hover { filter:brightness(1.08); transform:translateY(-1px); }

// .cs-check { position:absolute; top:14px; right:14px; width:22px; height:22px; border-radius:50%; display:flex; align-items:center; justify-content:center; font-size:11px; font-weight:800; }
// .cs-shell.dark  .cs-check { background:var(--ac-d); color:#050508; }
// .cs-shell.light .cs-check { background:var(--ac);   color:#fff; }

// .cs-progress { display:flex; gap:8px; }
// .cs-seg { height:5px; width:72px; border-radius:100px; transition:background 0.3s; }
// .cs-shell.dark  .cs-seg     { background:rgba(255,255,255,0.1); }
// .cs-shell.light .cs-seg     { background:#E5E7EB; }
// .cs-seg.on { background:#00FFD1; }
// .cs-shell.light .cs-seg.on  { background:#00C9A7; }

// .cs-nav { display:flex; align-items:center; justify-content:center; gap:20px; }
// .cs-back { background:none; border:none; cursor:pointer; font-family:'DM Sans',sans-serif; font-size:14px; font-weight:600; padding:8px 0; transition:color 0.2s, transform 0.2s; display:inline-flex; align-items:center; gap:4px; }
// .cs-shell.dark  .cs-back { color:#4A4760; }
// .cs-shell.light .cs-back { color:#9CA3AF; }
// .cs-back:hover { transform:translateX(-2px); }
// .cs-shell.dark  .cs-back:hover { color:#00FFD1; }
// .cs-shell.light .cs-back:hover { color:#00C9A7; }
// `;

// /* ── Component ───────────────────────────────────────────────────────────── */
// const StepCurrentlyStudying = ({ onSelect, onBack, theme, toggleTheme }) => {
//   const [selected, setSelected] = useState(null);
//   const isDark = (theme || 'dark') === 'dark';

//   return (
//     <>
//       <style>{CSS}</style>
//       <div className={`cs-shell ${theme || 'dark'}`}>
//         <div className="cs-orb cs-orb-1" />
//         <div className="cs-orb cs-orb-2" />
//         <div className="cs-grid" />

//         <TopMenu theme={theme} toggleTheme={toggleTheme} />

//         <div className="cs-page">

//           <motion.div className="cs-header"
//             initial={{ opacity:0, y:24 }} animate={{ opacity:1, y:0 }}
//             transition={{ duration:0.55, ease:[0.22,1,0.36,1] }}>
//             <div className="cs-badge">✦ STEP 2 OF 3</div>
//             <h1 className="cs-title">Are you currently<br /><span>studying?</span></h1>
//             <p className="cs-sub">This helps us show the most relevant resume sections for you.</p>
//           </motion.div>

//           <div className="cs-cards">
//             {OPTIONS.map((opt, i) => (
//               <motion.div
//                 key={opt.id}
//                 className={`cs-card ${selected === opt.id ? 'active' : ''}`}
//                 style={{
//                   '--ac':   opt.accent,
//                   '--ac-d': opt.accentD,
//                   '--glow': isDark
//                     ? `color-mix(in srgb, ${opt.accentD} 18%, transparent)`
//                     : `color-mix(in srgb, ${opt.accent}  12%, transparent)`,
//                 }}
//                 initial={{ opacity:0, y:32 }}
//                 animate={{ opacity:1, y:0 }}
//                 transition={{ delay:0.12 + i * 0.12, duration:0.5, ease:[0.22,1,0.36,1] }}
//                 whileTap={{ scale:0.985 }}
//                 onClick={() => setSelected(opt.id)}
//               >
//                 <div className="cs-glow" />

//                 <div className="cs-card-top">
//                   <div className="cs-card-icon">{opt.icon}</div>
//                   <span className="cs-card-tag">{opt.tag}</span>
//                 </div>

//                 <div className="cs-card-name">{opt.label}</div>
//                 <div className="cs-card-sub">{opt.sub}</div>
//                 <div className="cs-divider" />
//                 <p className="cs-card-desc">{opt.desc}</p>

//                 <button
//                   className="cs-card-cta"
//                   onClick={e => { e.stopPropagation(); setSelected(opt.id); onSelect(opt.id); }}
//                 >
//                   {opt.label} →
//                 </button>

//                 {selected === opt.id && (
//                   <motion.div
//                     className="cs-check"
//                     initial={{ scale:0 }} animate={{ scale:1 }}
//                     transition={{ type:'spring', stiffness:420, damping:22 }}>
//                     ✓
//                   </motion.div>
//                 )}
//               </motion.div>
//             ))}
//           </div>

//           <div className="cs-progress">
//             <div className="cs-seg on" />
//             <div className="cs-seg on" />
//             <div className="cs-seg" />
//           </div>

//           <div className="cs-nav">
//             <button className="cs-back" onClick={onBack}>← Back</button>
//           </div>

//         </div>
//       </div>
//     </>
//   );
// };

// export default StepCurrentlyStudying;

import React, { useState } from 'react';
import { motion } from 'framer-motion';
import TopMenu from '../../../../TopMenu';

/* ── SVG: Yes (green checkmark — currently studying) ────────────────────── */
const YesSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 512 512">
    <g>
      <path fill="#bc7c63" d="M286.738 479.474v12.793c0 10.898 8.835 19.733 19.733 19.733s19.733-8.835 19.733-19.733v-12.793zM306.471 265.982c-6.704 0-14.322-.497-20.763-1.444v78.058c-.036 1.625 1.248 3.147 3.076 3.147h37.42v-81.205a135.715 135.715 0 0 1-19.733 1.444z"/>
      <path fill="#ab6b51" d="M307.837 492.267v-12.793h-21.098v12.793c0 10.898 8.835 19.733 19.733 19.733 3.884 0 7.496-1.138 10.549-3.076-5.514-3.5-9.184-9.643-9.184-16.657zM306.471 265.982c-6.704 0-14.322-.497-20.763-1.444v78.057c-.036 1.626 1.247 3.147 3.076 3.147h19.052v-79.786c-.455.005-.907.026-1.365.026z"/>
      <path fill="#fed2a4" d="M358.991 342.652h-69.177c-1.829 0-3.112-1.522-3.076-3.147v-56.144c0-6.776-5.477-12.296-12.254-12.319h-.065a17.525 17.525 0 0 0-15.886 10.113c-6.513 13.947-4.54 29.318-24.97 49.65-10.077 10.029-23.81 15.519-38.027 15.519h-18.581v120.687h11.786a60.975 60.975 0 0 1 28.857 7.261 60.967 60.967 0 0 0 28.857 7.261h88.819c9.588 0 17.36-7.772 17.36-17.36s-7.772-17.36-17.36-17.36h7.905c9.588 0 17.36-7.772 17.36-17.36s-7.772-17.36-17.36-17.36h7.905c9.588 0 17.36-7.772 17.36-17.36s-7.772-17.36-17.36-17.36h7.905c9.588 0 17.36-7.772 17.36-17.36.002-9.589-7.77-17.361-17.358-17.361z"/>
      <path fill="#ffbd86" d="M206.833 361.539c0-8.046 3.951-15.165 10.014-19.537a54.65 54.65 0 0 1-21.31 4.322h-18.581v120.687h11.786c6.157 0 12.254.943 18.091 2.758z"/>
      <circle cx="306.471" cy="134.536" r="134.536" fill="#43cb8e"/>
      <path fill="#00ba66" d="M201.124 134.536c0-69.37 52.505-126.47 119.942-133.746-4.795-.517-9.663-.79-14.595-.79-74.302 0-134.536 60.234-134.536 134.536s60.234 134.536 134.536 134.536c4.932 0 9.8-.273 14.594-.79-67.436-7.276-119.941-64.376-119.941-133.746z"/>
      <circle cx="306.471" cy="134.536" r="107.879" fill="#00ba66"/>
      <path fill="#00a855" d="M227.781 134.536c0-54.63 40.608-99.768 93.285-106.893a108.77 108.77 0 0 0-14.594-.986c-59.58 0-107.879 48.299-107.879 107.879s48.299 107.879 107.879 107.879c4.95 0 9.821-.341 14.594-.986-52.677-7.125-93.285-52.264-93.285-106.893z"/>
      <g fill="#ffbd86">
        <path d="M335.276 446.813h7.91-47.626a7.726 7.726 0 1 0 0 15.452h56.966c-.951-8.688-8.308-15.452-17.25-15.452zM351.089 412.093H295.56a7.726 7.726 0 1 0 0 15.452h64.871c-.951-8.689-8.308-15.452-17.25-15.452h7.905zM295.56 392.825h72.777c-.95-8.689-8.308-15.453-17.25-15.453H295.56a7.726 7.726 0 0 0-7.726 7.726 7.726 7.726 0 0 0 7.726 7.727zM358.991 342.652h-66.866c-2.541 1.565-4.292 4.696-4.292 7.727a7.726 7.726 0 0 0 7.726 7.726h80.682c-.95-8.69-8.307-15.453-17.25-15.453z"/>
      </g>
      <path fill="#dfebfa" d="M173.162 333.304h-31.927v143.222h31.927a6.886 6.886 0 0 0 6.886-6.886V340.19a6.887 6.887 0 0 0-6.886-6.886z"/>
      <path fill="#b1dbfc" d="M141.235 333.304h22.64v143.222h-22.64z"/>
      <path fill="#60b8fe" d="M134.482 320.128H80.836c-5.436 0-9.843 4.407-9.843 9.843v149.888c0 5.436 4.407 9.843 9.843 9.843h53.646c5.436 0 9.843-4.407 9.843-9.843V329.971c.001-5.436-4.407-9.843-9.843-9.843z"/>
      <path fill="#23a8fe" d="M107.659 479.859V329.971c0-5.436 4.407-9.843 9.844-9.843H80.836c-5.436 0-9.843 4.407-9.843 9.843v149.888c0 5.436 4.407 9.843 9.843 9.843h36.667c-5.437.001-9.844-4.406-9.844-9.843z"/>
      <path fill="#dfebfa" d="M367.153 98.617c-6.207-6.821-16.776-7.008-23.222-.561l-46.821 46.821a3.227 3.227 0 0 1-4.565 0l-20.92-20.92c-6.446-6.447-17.015-6.26-23.221.561-5.813 6.389-5.251 16.338.857 22.446l34.224 34.224c6.264 6.265 16.423 6.265 22.686 0l60.125-60.125c6.108-6.108 6.67-16.057.857-22.446z"/>
      <path fill="#b1dbfc" d="m298.968 171.745-34.224-34.224c-4.882-4.882-6.209-12.215-3.581-18.226-4.632-.253-9.352 1.479-12.759 5.223-5.813 6.389-5.251 16.338.857 22.447l34.224 34.224c6.264 6.265 16.423 6.265 22.686 0l4.775-4.775c-4.315.17-8.685-1.375-11.978-4.669z"/>
    </g>
  </svg>
);

/* ── SVG: No (red X — not studying) ─────────────────────────────────────── */
const NoSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 512 512">
    <g>
      <path fill="#bc7c63" d="M286.738 479.474v12.793c0 10.898 8.835 19.733 19.733 19.733s19.733-8.835 19.733-19.733v-12.793zM306.471 265.982c-6.704 0-14.322-.497-20.763-1.444v78.058c-.036 1.626 1.248 3.147 3.076 3.147h37.42v-81.205a135.715 135.715 0 0 1-19.733 1.444z"/>
      <path fill="#ab6b51" d="M307.837 492.267v-12.793h-21.098v12.793c0 10.898 8.835 19.733 19.733 19.733 3.884 0 7.496-1.138 10.549-3.076-5.514-3.5-9.184-9.643-9.184-16.657zM306.471 265.982c-6.704 0-14.322-.497-20.763-1.444v78.057c-.036 1.625 1.247 3.147 3.076 3.147h19.052v-79.786c-.455.005-.907.026-1.365.026z"/>
      <path fill="#fed2a4" d="M358.991 342.652h-69.177c-1.829 0-3.112-1.522-3.076-3.147v-56.144c0-6.776-5.477-12.296-12.254-12.319h-.065a17.525 17.525 0 0 0-15.886 10.113c-6.513 13.947-4.54 29.318-24.97 49.65-10.077 10.029-23.81 15.519-38.027 15.519h-18.581v120.687h11.786a60.975 60.975 0 0 1 28.857 7.261 60.967 60.967 0 0 0 28.857 7.261h88.819c9.588 0 17.36-7.772 17.36-17.36s-7.772-17.36-17.36-17.36h7.905c9.588 0 17.36-7.772 17.36-17.36s-7.772-17.36-17.36-17.36h7.905c9.588 0 17.36-7.772 17.36-17.36s-7.772-17.36-17.36-17.36h7.905c9.588 0 17.36-7.772 17.36-17.36.002-9.589-7.77-17.361-17.358-17.361z"/>
      <path fill="#ffbd86" d="M206.833 361.539c0-8.046 3.951-15.165 10.014-19.537a54.65 54.65 0 0 1-21.31 4.322h-18.581v120.687h11.786c6.157 0 12.254.943 18.091 2.758z"/>
      <circle cx="306.471" cy="134.536" r="134.536" fill="#ff656f"/>
      <path fill="#ff4756" d="M201.124 134.536c0-69.37 52.505-126.47 119.942-133.746-4.795-.517-9.663-.79-14.595-.79-74.302 0-134.536 60.234-134.536 134.536s60.234 134.536 134.536 134.536c4.932 0 9.8-.273 14.594-.79-67.436-7.276-119.941-64.376-119.941-133.746z"/>
      <circle cx="306.471" cy="134.536" r="107.879" fill="#ff4756"/>
      <path fill="#fc2d39" d="M227.781 134.536c0-54.63 40.608-99.768 93.285-106.893a108.77 108.77 0 0 0-14.594-.986c-59.58 0-107.879 48.299-107.879 107.879s48.299 107.879 107.879 107.879c4.95 0 9.821-.341 14.594-.986-52.677-7.125-93.285-52.264-93.285-106.893z"/>
      <path fill="#dfebfa" d="M330.882 136.155a2.29 2.29 0 0 1 0-3.237l25.409-25.409c6.108-6.108 6.67-16.058.857-22.447-6.207-6.821-16.776-7.008-23.222-.561l-25.733 25.733a2.288 2.288 0 0 1-3.235-.002l-25.515-25.515c-6.108-6.108-16.057-6.67-22.446-.857-6.821 6.207-7.008 16.776-.561 23.222l25.838 25.839c.893.893.893 2.34 0 3.233l-25.838 25.839c-6.447 6.446-6.26 17.015.561 23.221 6.389 5.813 16.338 5.251 22.446-.857l25.515-25.515a2.288 2.288 0 0 1 3.235-.002l25.733 25.733c6.446 6.447 17.015 6.26 23.222-.561 5.813-6.389 5.251-16.338-.857-22.447l-25.409-25.41z"/>
      <path fill="#b1dbfc" d="m278.07 161.991 25.839-25.839a2.286 2.286 0 0 0 0-3.233L278.07 107.08c-6.426-6.425-6.257-16.944.499-23.159-6.149-5.339-15.477-5.608-21.572-.062-6.821 6.207-7.009 16.776-.561 23.222l25.839 25.839c.893.893.893 2.34 0 3.233l-25.839 25.839c-6.447 6.446-6.26 17.015.561 23.221 6.095 5.546 15.423 5.277 21.572-.062-6.757-6.215-6.926-16.735-.499-23.16z"/>
      <g fill="#ffbd86">
        <path d="M335.276 446.813h7.91-47.626a7.726 7.726 0 1 0 0 15.452h56.966c-.951-8.688-8.308-15.452-17.25-15.452zM351.089 412.093H295.56a7.726 7.726 0 1 0 0 15.452h64.871c-.951-8.689-8.308-15.452-17.25-15.452h7.905zM295.56 392.825h72.777c-.95-8.689-8.308-15.453-17.25-15.453H295.56a7.727 7.727 0 0 0 0 15.453zM358.991 342.652h-66.866c-2.541 1.565-4.292 4.696-4.292 7.727a7.726 7.726 0 0 0 7.726 7.726h80.682c-.95-8.69-8.307-15.453-17.25-15.453z"/>
      </g>
      <path fill="#dfebfa" d="M173.162 333.304h-31.927v143.222h31.927a6.886 6.886 0 0 0 6.886-6.886V340.19a6.887 6.887 0 0 0-6.886-6.886z"/>
      <path fill="#b1dbfc" d="M141.235 333.304h22.64v143.222h-22.64z"/>
      <path fill="#60b8fe" d="M134.482 320.128H80.836c-5.436 0-9.843 4.407-9.843 9.843v149.888c0 5.436 4.407 9.843 9.843 9.843h53.646c5.436 0 9.843-4.407 9.843-9.843V329.971c.001-5.436-4.407-9.843-9.843-9.843z"/>
      <path fill="#23a8fe" d="M107.659 479.859V329.971c0-5.436 4.407-9.843 9.844-9.843H80.836c-5.436 0-9.843 4.407-9.843 9.843v149.888c0 5.436 4.407 9.843 9.843 9.843h36.667c-5.437.001-9.844-4.406-9.844-9.843z"/>
    </g>
  </svg>
);

const OPTIONS = [
  {
    id: 'yes',
    tag: 'ENROLLED',
    icon: <YesSVG />,
    label: 'Yes, I am',
    sub: 'Currently studying',
    desc: "We'll include education highlights, academic projects and internships prominently.",
    accent: '#00C9A7',
    accentD: '#00FFD1',
  },
  {
    id: 'no',
    tag: 'GRADUATED',
    icon: <NoSVG />,
    label: "No, I'm not",
    sub: 'Already graduated',
    desc: "We'll focus on work experience, achievements and professional skills sections.",
    accent: '#0A66C2',
    accentD: '#4D9FFF',
  },
];

const CSS = `
.cs-shell { min-height:100vh; font-family:'DM Sans',sans-serif; -webkit-font-smoothing:antialiased; position:relative; overflow:hidden; }
.cs-shell.light { background:#F5F4F8; color:#1A1828; }
.cs-shell.dark  { background:#050508; color:#E8E6F0; }

.cs-orb { position:absolute; border-radius:50%; pointer-events:none; }
.cs-orb-1 { width:550px; height:550px; top:-180px; left:-150px; background:radial-gradient(circle, rgba(0,201,167,0.08) 0%, transparent 65%); }
.cs-orb-2 { width:450px; height:450px; bottom:-150px; right:-100px; background:radial-gradient(circle, rgba(10,102,194,0.08) 0%, transparent 65%); }

.cs-grid { position:absolute; inset:0; pointer-events:none; background-size:40px 40px; mask-image:radial-gradient(ellipse 80% 80% at 50% 50%, black, transparent); -webkit-mask-image:radial-gradient(ellipse 80% 80% at 50% 50%, black, transparent); }
.cs-shell.dark .cs-grid { background-image:linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px); }
.cs-shell.light .cs-grid { background-image:linear-gradient(rgba(0,0,0,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(0,0,0,0.04) 1px, transparent 1px); }

.cs-page { position:relative; z-index:1; min-height:calc(100vh - 64px); margin-top:64px; padding:64px 24px 80px; display:flex; flex-direction:column; align-items:center; gap:44px; }

.cs-header { text-align:center; max-width:560px; }

.cs-badge { display:inline-flex; align-items:center; gap:7px; font-size:11px; font-weight:700; letter-spacing:0.12em; text-transform:uppercase; padding:6px 14px; border-radius:100px; margin-bottom:20px; }
.cs-shell.dark .cs-badge { background:rgba(0,201,167,0.1); border:1px solid rgba(0,201,167,0.25); color:#00FFD1; }
.cs-shell.light .cs-badge { background:rgba(0,150,120,0.08); border:1px solid rgba(0,150,120,0.2); color:#007A5E; }

.cs-title { font-family:'Syne',sans-serif; font-size:clamp(26px,4vw,40px); font-weight:800; letter-spacing:-0.04em; line-height:1.1; margin-bottom:14px; }
.cs-shell.dark .cs-title { color:#F0EEF8; }
.cs-shell.light .cs-title { color:#1A1828; }
.cs-title span { background:linear-gradient(135deg,#00FFD1,#4D9FFF); -webkit-background-clip:text; background-clip:text; -webkit-text-fill-color:transparent; }
.cs-shell.light .cs-title span { background:linear-gradient(135deg,#00C9A7,#0A66C2); -webkit-background-clip:text; background-clip:text; -webkit-text-fill-color:transparent; }

.cs-sub { font-size:15px; line-height:1.7; }
.cs-shell.dark .cs-sub { color:#6E6B80; }
.cs-shell.light .cs-sub { color:#8B879E; }

.cs-cards { display:grid; grid-template-columns:repeat(2,1fr); gap:20px; width:100%; max-width:640px; }
@media(max-width:580px){ .cs-cards{ grid-template-columns:1fr; } }

.cs-card { border-radius:20px; padding:28px 22px 22px; cursor:pointer; position:relative; overflow:hidden; border:1.5px solid; text-align:left; background:none; display:flex; flex-direction:column; transition:transform 0.22s, box-shadow 0.22s, border-color 0.22s; }
.cs-shell.dark .cs-card { background:#0D0D12; border-color:rgba(255,255,255,0.06); }
.cs-shell.light .cs-card { background:#FFFFFF; border-color:rgba(0,0,0,0.08); box-shadow:0 2px 16px rgba(0,0,0,0.05); }

.cs-card:hover { transform:translateY(-6px); }
.cs-shell.dark .cs-card:hover { border-color:var(--ac-d); box-shadow:0 12px 40px color-mix(in srgb, var(--ac-d) 18%, transparent); }
.cs-shell.light .cs-card:hover { border-color:var(--ac); box-shadow:0 12px 40px color-mix(in srgb, var(--ac) 15%, transparent); }
.cs-shell.dark .cs-card.active { border-color:var(--ac-d); box-shadow:0 0 0 3px color-mix(in srgb, var(--ac-d) 18%, transparent); transform:translateY(-6px); }
.cs-shell.light .cs-card.active { border-color:var(--ac); box-shadow:0 0 0 3px color-mix(in srgb, var(--ac) 15%, transparent); transform:translateY(-6px); }

.cs-glow { position:absolute; inset:0; border-radius:20px; pointer-events:none; opacity:0; transition:opacity 0.35s; background:radial-gradient(ellipse at 50% 0%, var(--glow,transparent), transparent 70%); }
.cs-card:hover .cs-glow, .cs-card.active .cs-glow { opacity:1; }

.cs-card-top { display:flex; justify-content:space-between; align-items:flex-start; margin-bottom:16px; }
.cs-card-icon { transition:transform 0.25s; flex-shrink:0; }
.cs-card:hover .cs-card-icon { transform:scale(1.08) translateY(-2px); }

.cs-card-tag { font-size:10px; font-weight:700; letter-spacing:0.1em; padding:4px 10px; border-radius:100px; align-self:flex-start; margin-top:4px; }
.cs-shell.dark .cs-card-tag { color:var(--ac-d); background:color-mix(in srgb, var(--ac-d) 12%, transparent); border:1px solid color-mix(in srgb, var(--ac-d) 30%, transparent); }
.cs-shell.light .cs-card-tag { color:var(--ac); background:color-mix(in srgb, var(--ac) 10%, transparent); border:1px solid color-mix(in srgb, var(--ac) 25%, transparent); }

.cs-card-name { font-family:'Syne',sans-serif; font-size:20px; font-weight:800; letter-spacing:-0.02em; margin-bottom:4px; }
.cs-shell.dark .cs-card-name { color:#EDEAF5; }
.cs-shell.light .cs-card-name { color:#1A1828; }

.cs-card-sub { font-size:12px; font-weight:500; margin-bottom:12px; }
.cs-shell.dark .cs-card-sub { color:#4A4760; }
.cs-shell.light .cs-card-sub { color:#B0ACC4; }

.cs-divider { height:1px; margin-bottom:14px; }
.cs-shell.dark .cs-divider { background:rgba(255,255,255,0.06); }
.cs-shell.light .cs-divider { background:rgba(0,0,0,0.06); }

.cs-card-desc { font-size:13px; line-height:1.65; margin-bottom:20px; flex:1; }
.cs-shell.dark .cs-card-desc { color:#6E6B80; }
.cs-shell.light .cs-card-desc { color:#8B879E; }

.cs-card-cta { width:100%; padding:11px 0; border-radius:10px; border:none; font-family:'DM Sans',sans-serif; font-size:14px; font-weight:700; cursor:pointer; transition:filter 0.2s, transform 0.15s; }
.cs-shell.dark .cs-card-cta { background:var(--ac-d); color:#050508; }
.cs-shell.light .cs-card-cta { background:var(--ac); color:#fff; }
.cs-card-cta:hover { filter:brightness(1.08); transform:translateY(-1px); }

.cs-check { position:absolute; top:14px; right:14px; width:22px; height:22px; border-radius:50%; display:flex; align-items:center; justify-content:center; font-size:11px; font-weight:800; }
.cs-shell.dark .cs-check { background:var(--ac-d); color:#050508; }
.cs-shell.light .cs-check { background:var(--ac); color:#fff; }

.cs-progress { display:flex; gap:8px; }
.cs-seg { height:5px; width:72px; border-radius:100px; transition:background 0.3s; }
.cs-shell.dark .cs-seg { background:rgba(255,255,255,0.1); }
.cs-shell.light .cs-seg { background:#E5E7EB; }
.cs-seg.on { background:#00FFD1; }
.cs-shell.light .cs-seg.on { background:#00C9A7; }

.cs-nav { display:flex; align-items:center; justify-content:center; gap:20px; }
.cs-back { background:none; border:none; cursor:pointer; font-family:'DM Sans',sans-serif; font-size:14px; font-weight:600; padding:8px 0; transition:color 0.2s, transform 0.2s; display:inline-flex; align-items:center; gap:4px; }
.cs-shell.dark .cs-back { color:#4A4760; }
.cs-shell.light .cs-back { color:#9CA3AF; }
.cs-back:hover { transform:translateX(-2px); }
.cs-shell.dark .cs-back:hover { color:#00FFD1; }
.cs-shell.light .cs-back:hover { color:#00C9A7; }
`;

const StepCurrentlyStudying = ({ onSelect, onBack, theme, toggleTheme }) => {
  const [selected, setSelected] = useState(null);
  const isDark = (theme || 'dark') === 'dark';

  const handleChoose = (id) => {
    setSelected(id);
    setTimeout(() => {
      onSelect(id);
    }, 120);
  };

  return (
    <>
      <style>{CSS}</style>
      <div className={`cs-shell ${theme || 'dark'}`}>
        <div className="cs-orb cs-orb-1" />
        <div className="cs-orb cs-orb-2" />
        <div className="cs-grid" />

        <TopMenu theme={theme} toggleTheme={toggleTheme} />

        <div className="cs-page">
          <motion.div
            className="cs-header"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="cs-badge">✦ STEP 2 OF 3</div>
            <h1 className="cs-title">
              Are you currently<br />
              <span>studying?</span>
            </h1>
            <p className="cs-sub">
              This helps us show the most relevant resume sections for you.
            </p>
          </motion.div>

          <div className="cs-cards">
            {OPTIONS.map((opt, i) => (
              <motion.div
                key={opt.id}
                className={`cs-card ${selected === opt.id ? 'active' : ''}`}
                style={{
                  '--ac': opt.accent,
                  '--ac-d': opt.accentD,
                  '--glow': isDark
                    ? `color-mix(in srgb, ${opt.accentD} 18%, transparent)`
                    : `color-mix(in srgb, ${opt.accent} 12%, transparent)`,
                }}
                initial={{ opacity: 0, y: 32 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.12 + i * 0.12, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                whileTap={{ scale: 0.985 }}
                onClick={() => handleChoose(opt.id)}
              >
                <div className="cs-glow" />

                <div className="cs-card-top">
                  <div className="cs-card-icon">{opt.icon}</div>
                  <span className="cs-card-tag">{opt.tag}</span>
                </div>

                <div className="cs-card-name">{opt.label}</div>
                <div className="cs-card-sub">{opt.sub}</div>
                <div className="cs-divider" />
                <p className="cs-card-desc">{opt.desc}</p>

                <button
                  className="cs-card-cta"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleChoose(opt.id);
                  }}
                >
                  {opt.label} →
                </button>

                {selected === opt.id && (
                  <motion.div
                    className="cs-check"
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ type: 'spring', stiffness: 420, damping: 22 }}
                  >
                    ✓
                  </motion.div>
                )}
              </motion.div>
            ))}
          </div>

          <div className="cs-progress">
            <div className="cs-seg on" />
            <div className="cs-seg on" />
            <div className="cs-seg" />
          </div>

          <div className="cs-nav">
            <button className="cs-back" onClick={onBack}>← Back</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default StepCurrentlyStudying;